import {
  Dialog,
  DialogContent,
  IconButton,
  Toolbar,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Stack,
  Autocomplete,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  Tab,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState, useRef } from "react";
import { DateRangePicker } from "rsuite";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import ExpandableContentRow from "./ExpandableContentRow";
import {
  DateFormater,
  formatAmount,
  GetReadOnlyInputProps,
  handleSessionOut,
  Loader,
} from "../../../../../HelperFunctions/HelperFunctions";
import ViewTransactionsRanges from "../../../../../HelperFunctions/ViewTransactionsRanges";
import { useRouteLoaderData } from "react-router-dom";
import {
  manualReconcile,
  reconciliationDetails,
} from "../../../../../API/backendAPI";
import { enqueueSnackbar } from "notistack";
import success from "../../../../../Images/success.png";

const MerchantReconciliationDialog = ({
  open,
  onClose,
  gridCorp,
  merchantDetails,
  setMerchantDetails,
  defaultDateRange,
  userPreference,
  pcid,
  bankId,
  pcName
}) => {
  const { corporations, userId, clientId } =
    useRouteLoaderData("reconciliation");
  const corp = corporations.find((c) => c.ID === gridCorp);
  const viewTransaction = ViewTransactionsRanges();
  const tabNames =
    merchantDetails?.cards_data?.map((card) => card.group_id) || [];
  const [selectedTab, setSelectedTab] = useState(tabNames[0]);
  const [expandStates, setExpandStates] = useState({});
  const [loading, setLoading] = useState(false);

  const [diffAmt, setDiffAmt] = useState(0);
  const [linkBatch, setLinkBatch] = useState({
    merchant_ids: [],
    sale_ids: [],
  });
  // Store linkBatch selections per section/tab combination
  const [linkBatchSelections, setLinkBatchSelections] = useState({});
  // Track if we're currently restoring selections to avoid saving during restoration
  const isRestoringRef = useRef(false);
  // Store scroll positions per section/tab combination
  const [scrollPositions, setScrollPositions] = useState({});
  // Store page state for BatchAmountTable keyed by tab-section
  const [batchTablePages, setBatchTablePages] = useState({});
  // Store page state for NimbleAmountTable keyed by tab-section
  const [nimbleTablePages, setNimbleTablePages] = useState({});
  // Store page state for MatchedAmountTable keyed by tab-section
  const [matchedTablePages, setMatchedTablePages] = useState({});
  // Store page state for ChargebacksOrFeeTable keyed by tab-section
  const [chargebackTablePages, setChargebackTablePages] = useState({});

  // console.log("this is pc id from merchint popup",pcid)

  // const thisMonthOption = viewTransaction.find(
  //   (opt) => opt.date === "This Month"
  // );

  const batchCardCache = useRef({});
  const nimbleCardsCache = useRef({});

  const lastMonthOption = viewTransaction.find(
    (opt) => opt.date === "Last Month",
  );

  const today = (() => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);

    const end = new Date();
    end.setHours(23, 59, 59, 999);

    return [start, end];
  })();


  const dateRange =
    defaultDateRange?.fromDate && defaultDateRange?.toDate
      ? [new Date(defaultDateRange.fromDate), new Date(defaultDateRange.toDate)]
      : lastMonthOption
        ? [lastMonthOption.actualValue.start, lastMonthOption.actualValue.end]
        : [null, null];

  const initialFilters = {
    selectedCorp: corp || corporations[0],
    dateRange,
    viewTransaction:
      defaultDateRange?.fromDate && defaultDateRange?.toDate
        ? "Range"
        : "Last Month",
    data: null,
    tab: selectedTab,
  };

  // const initialFilters = {
  //   selectedCorp: corp || corporations[0],
  //   dateRange: thisMonthOption
  //     ? [thisMonthOption.actualValue.start, thisMonthOption.actualValue.end]
  //     : [null, null],
  //   viewTransaction: "This Month",
  //   data: null,
  //   tab: selectedTab,
  // };
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      tab: selectedTab,
    }));
    if (selectedTab) {
      setExpandStates((prev) => ({
        ...prev,
        [selectedTab]: { "To be Matched": true },
      }));

      // Restore selections for the new tab if "To be Matched" is expanded
      const selectionKey = `${selectedTab}-To be Matched`;
      const savedSelections = linkBatchSelections[selectionKey];
      if (savedSelections) {
        isRestoringRef.current = true;
        setTimeout(() => {
          setLinkBatch({
            merchant_ids: [...savedSelections.merchant_ids],
            sale_ids: [...savedSelections.sale_ids],
          });
          setTimeout(() => {
            isRestoringRef.current = false;
          }, 100);
        }, 0);
      } else {
        setLinkBatch({ merchant_ids: [], sale_ids: [] });
      }
    }
  }, [selectedTab]);

  // Save selections whenever linkBatch changes for "To be Matched" section
  // Skip saving if we're currently restoring selections
  useEffect(() => {
    if (isRestoringRef.current) {
      return;
    }
    if (selectedTab && expandStates[selectedTab]?.["To be Matched"]) {
      const selectionKey = `${selectedTab}-To be Matched`;
      setLinkBatchSelections((prevSelections) => ({
        ...prevSelections,
        [selectionKey]: {
          merchant_ids: [...linkBatch.merchant_ids],
          sale_ids: [...linkBatch.sale_ids],
        },
      }));
    }
  }, [linkBatch, selectedTab, expandStates]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => {
      const updated = { ...prev, [field]: value };

      if (field === "viewTransaction") {
        const match = viewTransaction.find((opt) => opt.date === value);
        if (match) {
          updated.dateRange = [match.actualValue.start, match.actualValue.end];
        }
      }

      if (field === "dateRange" && value) {
        const [start, end] = value;
        const matched = viewTransaction.find((opt) => {
          const optStart = opt.actualValue.start;
          const optEnd = opt.actualValue.end;
          return (
            optStart?.getTime?.() === start?.getTime?.() &&
            optEnd?.getTime?.() === end?.getTime?.()
          );
        });
        updated.viewTransaction = matched ? matched.date : "Range";
      }

      return updated;
    });
  };

  const getReconciliationDetails = async (tab) => {
    // console.log("tabbbbb",tab)
    // const { selectedCorp, dateRange } = filters[tab];
    const { selectedCorp, dateRange } = filters;
    if (selectedCorp.ID === "select" || (!dateRange[0] && !dateRange[1])) {
      enqueueSnackbar("Please select the corporation and date", {
        variant: "warning",
      });
      return;
    }
    setLoading(true);

    try {
      const payload = {
        bank_account_id: bankId,
        client_id: clientId,
        user_id: userId,
        corp_id: selectedCorp.ID,
        from_date: DateFormater(dateRange[0]),
        to_date: DateFormater(dateRange[1]),
        merchant_provider:
          merchantDetails?.cards_data?.length > 1
            ? null
            : merchantDetails?.cards_data?.[0]?.merchant_provider,
        pc_id: pcid,

      };

      const data = await reconciliationDetails(payload);
      setMerchantDetails(data);
      setExpandStates((prev) => {
        const currentExpandedSection = prev[tab] ||
          prev[selectedTab] || { "To be Matched": true };
        return {
          ...prev,
          [tab]: currentExpandedSection,
        };
      });
      if (data?.cards_data?.length > 0) {
        // setSelectedTab(data.cards_data[0].recon_uniq_id);
        setSelectedTab(tab);
      } else {
        enqueueSnackbar(
          "Imported data is not available for selected corporation",
          { variant: "warning" },
        );
      }
      // setFilters((prev) => ({
      //     ...prev,
      //     [tab]: {
      //         ...prev[tab],
      //         data,
      //     },
      // }));
      setFilters((prev) => ({
        ...prev,
        data,
      }));
      // Don't clear linkBatch here - preserve selections when refreshing data
      // Only clear if there's no saved selection for this section
      // const selectionKey = `${tab}-To be Matched`;
      // const savedSelections = linkBatchSelections[selectionKey];
      // if (!savedSelections || (savedSelections.merchant_ids.length === 0 && savedSelections.sale_ids.length === 0)) {
      //   setLinkBatch({ merchant_ids: [], sale_ids: [] });
      // } else {
      //   // Restore saved selections after data refresh
      //   isRestoringRef.current = true;
      //   setTimeout(() => {
      //     setLinkBatch({
      //       merchant_ids: [...savedSelections.merchant_ids],
      //       sale_ids: [...savedSelections.sale_ids],
      //     });
      //     setTimeout(() => {
      //       isRestoringRef.current = false;
      //     }, 100);
      //   }, 0);
      // }

      setLinkBatch({ merchant_ids: [], sale_ids: [] });
    } catch (error) {
      enqueueSnackbar("Error while getting ReconciliationDetails", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLinkBatch = async (selectionOverride) => {
    setLoading(true);
    try {
      const batchData = (
        merchantDetails?.to_be_matched?.unreconciled_merchants || []
      ).filter((item) => item.group_id === selectedTab);
      const saleData = (
        merchantDetails?.to_be_matched?.unreconciled_sales || []
      ).filter((item) => item.group_id === selectedTab);

      const requestedMerchantIds =
        selectionOverride?.merchant_ids ?? linkBatch?.merchant_ids ?? [];
      const requestedSaleIds =
        selectionOverride?.sale_ids ?? linkBatch?.sale_ids ?? [];

      // Normalize IDs to avoid stale/duplicate selection artifacts in rapid consecutive links.
      const normalizedMerchantIds = [...new Set(requestedMerchantIds)].filter(
        (id) => batchData.some((item) => item._id === id),
      );
      const normalizedSaleIds = [...new Set(requestedSaleIds)].filter((id) =>
        saleData.some((item) => item._id === id),
      );

      const effectiveLinkBatch = {
        merchant_ids: normalizedMerchantIds,
        sale_ids: normalizedSaleIds,
      };

      if (diffAmt === 0 || diffAmt > 0) {
        if (effectiveLinkBatch.merchant_ids.length === 0) {
          enqueueSnackbar("Batch selections is required", {
            variant: "warning",
          });
          return false;
        }
        if (effectiveLinkBatch.sale_ids.length === 0) {
          enqueueSnackbar("Nimble selections is required", {
            variant: "warning",
          });
          return false;
        }
        // if (diffAmt > 0) {
        //     enqueueSnackbar("Difference amount must be 0", { variant: "warning" });
        //     return false;
        // }
      }

      if (diffAmt < 0) {
        if (effectiveLinkBatch.merchant_ids.length === 0) {
          enqueueSnackbar("Batch selections is required", {
            variant: "warning",
          });
          return false;
        }
        if (effectiveLinkBatch.sale_ids.length === 0) {
          enqueueSnackbar("Nimble selections is required", {
            variant: "warning",
          });
          return false;
        }

        const selectedMerchants = batchData.filter((merchant) =>
          effectiveLinkBatch.merchant_ids.includes(merchant._id),
        );
        const selectedSales = saleData.filter((sale) =>
          effectiveLinkBatch.sale_ids.includes(sale._id),
        );

        const normalizeCardType = (value) =>
          (value || "")
            .toLowerCase()
            .replace(/,/g, "")
            .replace(/\s+/g, " ")
            .trim();

        const expandCardType = (value) => {
          const normalized = normalizeCardType(value);
          if (!normalized) {
            return [];
          }

          if (
            normalized === "visa & mastercard"

          ) {
            return ["visa", "mastercard"];
          }

          const normalizedBase = normalized
            .replace(/\bamerican express\b/g, "amex")
            .replace(/\bcredit\b/g, "")
            .replace(/\bdebit\b/g, "")
            .replace(/\bcard\b/g, "")
            .replace(/\s+/g, " ")
            .trim();

          if (!normalizedBase) {
            return [];
          }

          if (normalizedBase.includes("&")) {
            return normalizedBase
              .split("&")
              .map((item) => item.trim())
              .filter(Boolean);
          }

          return [normalizedBase];
        };

        const merchantCardTypes = [
          ...new Set(
            selectedMerchants.flatMap((merchant) =>
              expandCardType(merchant.card_type),
            ),
          ),
        ];
        const saleCardTypes = [
          ...new Set(
            selectedSales.flatMap((sale) => expandCardType(sale.card_type)),
          ),
        ];

        const merchantSet = new Set(merchantCardTypes);
        const saleSet = new Set(saleCardTypes);
        const hasOverlap = merchantCardTypes.some((type) => saleSet.has(type));
        const merchantSubsetSale = merchantCardTypes.every((type) =>
          saleSet.has(type),
        );
        const saleSubsetMerchant = saleCardTypes.every((type) =>
          merchantSet.has(type),
        );
        const isValid = hasOverlap && (merchantSubsetSale || saleSubsetMerchant);

        if (!isValid) {
          enqueueSnackbar("Batch and Nimble must have the same Card Type!", {
            variant: "warning",
          });
          return false;
        }
      }

      const { selectedCorp, tab } = filters;
      const payload = {
        ...effectiveLinkBatch,
        user_id: userId,
        corp_id: selectedCorp.ID,
        pcid: selectedCorp.ProfitCenterID,
      };

      const link = await manualReconcile(payload);
      if (link.status === "success") {
        enqueueSnackbar("Link batch successful", { variant: "success" });
      }

      await getReconciliationDetails(selectedTab);
      // Clear selections after successful link
      setLinkBatch({ merchant_ids: [], sale_ids: [] });
      // Also clear saved selections for this section
      const selectionKey = `${selectedTab}-To be Matched`;
      setLinkBatchSelections((prevSelections) => {
        const updated = { ...prevSelections };
        delete updated[selectionKey];
        return updated;
      });
      setSelectedTab(tab);
      return true;
    } catch (error) {
      if (error.status === 400) {
        enqueueSnackbar("Error: Sales line item does not have split enabled", {
          variant: "error",
        });
      } else if (error.status === 500) {
        enqueueSnackbar("Internal server error", { variant: "error" });
      } else if (error.status === 401) {
        handleSessionOut();
      } else {
        enqueueSnackbar("Error while Link Batch", { variant: "error" });
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  const TabHeading = ({ tab }) => {
    const {
      card_name,
      sales_unreconcile_count,
      unreconcile_sales_data_sum_amount,
      reconciled_sales_data_sum,
    } = tab;
    return (
      <Stack width="100%">
        <Typography noWrap fontSize={13} fontWeight={500}>
          {sales_unreconcile_count <= 0 ? (
            <img
              src={success}
              height={17}
              width={17}
              style={{ marginRight: 5 }}
            />
          ) : (
            ""
          )}
          {card_name} <small>({sales_unreconcile_count})</small>
        </Typography>
        <Stack direction="row" justifyContent="space-between" px={2}>
          <Stack>
            <Typography fontSize={9}>Open</Typography>
            <Typography fontSize={11} fontWeight={500}>
              $ {formatAmount(unreconcile_sales_data_sum_amount)}
            </Typography>
          </Stack>
          <Stack>
            <Typography fontSize={9}>Matched</Typography>
            <Typography fontSize={11} fontWeight={500}>
              $ {formatAmount(reconciled_sales_data_sum)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  };

  const ExpandableTableSection = ({ title, count, isExpanded, onToggle }) => (
    <TableRow sx={{ backgroundColor: "#ecffff" }}>
      <TableCell>
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{title}</Typography>
      </TableCell>
      <TableCell
        align="right"
        sx={{
          backgroundColor: "#d1f5f2",
          cursor: "pointer",
          p: 0,
          width: "200px",
        }}
        onClick={onToggle}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          py={1.5}
        >
          <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
            Transactions ({count})
          </Typography>
          {isExpanded ? <ArrowUpward /> : <ArrowDownward />}
        </Box>
      </TableCell>
    </TableRow>
  );

  const expandSection = (tab, section) => {
    setExpandStates((prev) => {
      const currentTab = prev[tab] || {};
      const isExpanded = currentTab[section] || false;

      // If collapsing "To be Matched" section, save current selections
      if (isExpanded && section === "To be Matched") {
        const selectionKey = `${tab}-${section}`;
        setLinkBatchSelections((prevSelections) => ({
          ...prevSelections,
          [selectionKey]: {
            merchant_ids: [...linkBatch.merchant_ids],
            sale_ids: [...linkBatch.sale_ids],
          },
        }));
      }

      // If expanding "To be Matched" section, restore saved selections
      if (!isExpanded && section === "To be Matched") {
        const selectionKey = `${tab}-${section}`;
        const savedSelections = linkBatchSelections[selectionKey];
        if (savedSelections) {
          isRestoringRef.current = true;
          // Use setTimeout to ensure state update happens after expand state is set
          setTimeout(() => {
            setLinkBatch({
              merchant_ids: [...savedSelections.merchant_ids],
              sale_ids: [...savedSelections.sale_ids],
            });
            setTimeout(() => {
              isRestoringRef.current = false;
            }, 100);
          }, 0);
        } else {
          setLinkBatch({ merchant_ids: [], sale_ids: [] });
        }
      }

      return {
        ...prev,
        [tab]: isExpanded ? {} : { [section]: true },
      };
    });
  };

  // Function to save scroll position for a table
  const saveScrollPosition = (tab, section, tableType, scrollTop) => {
    const scrollKey = `${tab}-${section}-${tableType}`;
    setScrollPositions((prev) => ({
      ...prev,
      [scrollKey]: scrollTop,
    }));
  };

  // Function to get scroll position for a table
  const getScrollPosition = (tab, section, tableType) => {
    const scrollKey = `${tab}-${section}-${tableType}`;
    return scrollPositions[scrollKey] || 0;
  };

  const groupMerchantsByName = (merchantMap) => {
    const groupedMerchants = {};

    merchantMap.forEach((item) => {
      const [id, name] = Array.isArray(item) ? item : [item.id, item.name];

      (groupedMerchants[name] ??= []).push(id);
    });

    return groupedMerchants;
  };

  const userPref = Boolean(userPreference?.IsShowCorpLegalName);

  const corpDisplayName = filters.selectedCorp
    ? userPref
      ? filters.selectedCorp.LegalName
      : filters.selectedCorp.Name
    : "";


  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <Box display="flex" flexDirection="column" height="100vh">
        <Toolbar style={{ backgroundColor: "#d7d7d7", minHeight: "50px" }}>

          <Typography
            sx={{ flex: 1, color: "#1f1f1f" }}
            fontWeight={600}
            fontSize={"18px"}
          >
            Merchant Reconciliation
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            style={{ backgroundColor: "#686868", borderRadius: "50%" }}
            disableRipple
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Toolbar>

        <DialogContent
          sx={{
            p: 0.5,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Stack height={"100%"} gap={2} p={0.5}>
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              width={"100%"}
            >
              <Tabs
                value={selectedTab}
                onChange={(e, newTab) => {
                  if (newTab) {
                    // Save current selections before switching tabs
                    const currentSection = expandStates[selectedTab];
                    if (currentSection && currentSection["To be Matched"]) {
                      const selectionKey = `${selectedTab}-To be Matched`;
                      setLinkBatchSelections((prevSelections) => ({
                        ...prevSelections,
                        [selectionKey]: {
                          merchant_ids: [...linkBatch.merchant_ids],
                          sale_ids: [...linkBatch.sale_ids],
                        },
                      }));
                    }

                    setSelectedTab(newTab);

                    // Restore selections for the new tab if "To be Matched" is expanded
                    const newTabSection = expandStates[newTab];
                    if (newTabSection && newTabSection["To be Matched"]) {
                      const selectionKey = `${newTab}-To be Matched`;
                      const savedSelections = linkBatchSelections[selectionKey];
                      if (savedSelections) {
                        isRestoringRef.current = true;
                        setTimeout(() => {
                          setLinkBatch({
                            merchant_ids: [...savedSelections.merchant_ids],
                            sale_ids: [...savedSelections.sale_ids],
                          });
                          setTimeout(() => {
                            isRestoringRef.current = false;
                          }, 100);
                        }, 0);
                      } else {
                        setLinkBatch({ merchant_ids: [], sale_ids: [] });
                      }
                    } else {
                      setLinkBatch({ merchant_ids: [], sale_ids: [] });
                    }
                  }
                }}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                // centered
                TabIndicatorProps={{ style: { display: "none" } }}
                sx={{
                  border: "1px solid #d7d7d7",
                  borderRadius: 2,
                  "& .MuiTab-root": {
                    p: 0.5,
                    minWidth: "250px",
                    color: "black",

                    textTransform: "none",
                    flexShrink: 0,
                    "&:not(:last-child)": {
                      borderRight: "1px solid #d7d7d7",
                    },
                    "&:first-of-type": {
                      borderTopLeftRadius: "8px",
                      borderBottomLeftRadius: "8px",
                    },
                    "&:last-of-type": {
                      borderTopRightRadius: "8px",
                      borderBottomRightRadius: "8px",
                      borderLeft: "none",
                    },
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#bee9e9",
                    color: "black !important",
                  },
                }}
              >
                {merchantDetails?.cards_data?.map((tab) => (
                  <Tab
                    key={tab.recon_uniq_id}
                    value={tab.group_id}
                    label={<TabHeading tab={tab} />}
                  />
                ))}
              </Tabs>
            </Box>
            <Stack direction="row" gap={5} alignItems="flex-end">
              <Autocomplete
                forcePopupIcon={false}
                readOnly
                options={corporations}
                size="small"
                disableClearable
                getOptionDisabled={(option) => option.ID === "select"}
                // getOptionLabel={(option) => option.Name}
                // isOptionEqualToValue={(option, value) =>
                //   option.ID === value?.ID
                // }
                // value={filters[selectedTab]?.selectedCorp || null}
                // onChange={(e, val) => handleFilterChange(selectedTab, "selectedCorp", val)}
                // value={filters.selectedCorp || null}
                value={corpDisplayName}
                // onChange={(e, val) => handleFilterChange("selectedCorp", val)}
                sx={{ maxWidth: "250px", flexGrow: 1 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // {...(
                    //     ["Select corporation"].includes(params.inputProps?.value)
                    //     && GetReadOnlyInputProps(params)
                    // )}
                    label="Corporation"
                    variant="filled"
                  />
                )}
              />


              {pcName && pcName !== "NA" && (
                <TextField
                  label="Profit Center"
                  variant="filled"
                  size="small"
                  value={pcName}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{ maxWidth: "210px", flexGrow: 1 }}
                />
              )}

              <Autocomplete
                options={viewTransaction.map((opt) => opt.date)}
                size="small"
                disableClearable
                value={filters.viewTransaction || ""}
                onChange={(e, val) =>
                  handleFilterChange("viewTransaction", val)
                }
                sx={{ maxWidth: "250px", flexGrow: 1 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    {...GetReadOnlyInputProps(params)}
                    label="View Transaction"
                    variant="filled"
                  />
                )}
              />
              <Stack>
                <Typography fontSize="10px" fontWeight={400} color="#7b7b7b">
                  From & To
                </Typography>
                <DateRangePicker
                  // value={filters[selectedTab]?.dateRange || [null, null]}
                  // onChange={(range) => handleFilterChange(selectedTab, "dateRange", range)}
                  value={filters.dateRange || [null, null]}
                  onChange={(range) => handleFilterChange("dateRange", range)}
                  menuStyle={{ zIndex: 1400, fontFamily: "Poppins" }}
                  format="MM/dd/yyyy"
                  size="lg"
                  // oneTap
                  ranges={[
                    {
                      label: "Today",
                      value: today,
                    },
                    {
                      label: "Clear",
                      value: null,
                    },
                  ]}
                />
              </Stack>

              <Button
                disableElevation
                variant="contained"
                color="black"
                sx={{
                  backgroundColor: "#b5dcf2",
                  textTransform: "none",
                  px: 3,
                }}
                onClick={() => getReconciliationDetails(selectedTab)}
              // onClick={() => {
              //   const confirmAction = window.confirm("Are you sure you want to proceed?");
              //   if (!confirmAction) return;

              //   getReconciliationDetails(selectedTab);
              // }}
              >
                Get
              </Button>
            </Stack>

            <Table>
              <TableBody>
                {["To be Matched", "Matched", "Chargebacks / Fee"].map(
                  (section, index) => {
                    let sectionData;
                    let count = 0;

                    if (section === "To be Matched") {
                      sectionData = {
                        unreconciled_merchants:
                          merchantDetails.to_be_matched.unreconciled_merchants.filter(
                            (item) => item.group_id === selectedTab,
                          ),
                        unreconciled_sales:
                          merchantDetails.to_be_matched.unreconciled_sales.filter(
                            (item) => item.group_id === selectedTab,
                          ),
                      };
                      count = sectionData?.unreconciled_merchants?.length || 0;
                    } else if (section === "Matched") {
                      sectionData = merchantDetails.matched.filter(
                        (item) => item.group_id === selectedTab,
                      );
                      count = sectionData?.length || 0;
                    } else if (section === "Chargebacks / Fee") {
                      sectionData =
                        merchantDetails.fees_data ||
                        // ?.filter(
                        //     (item) => item.recon_uniq_id === selectedTab
                        // )
                        [];
                      count = sectionData?.length || 0;
                    }

                    // const count =
                    //     section === "To be Matched"
                    //         ? sectionData.unreconciled_merchants.length
                    //         : sectionData.length;

                    return (
                      <>
                        <ExpandableTableSection
                          key={section}
                          title={section}
                          count={count}
                          isExpanded={!!expandStates[selectedTab]?.[section]}
                          onToggle={() => expandSection(selectedTab, section)}
                        />

                        {expandStates[selectedTab]?.[section] && (
                          <ExpandableContentRow
                            merchantDetails={merchantDetails}
                            setLoading={setLoading}
                            data={sectionData}
                            key={`${selectedTab}-${section}`}
                            tab={selectedTab}
                            section={section}
                            handleLinkBatch={handleLinkBatch}
                            linkBatch={linkBatch}
                            setLinkBatch={setLinkBatch}
                            setDiffAmt={setDiffAmt}
                            getReconciliationDetails={getReconciliationDetails}
                            selectedCorp={filters.selectedCorp}
                            batchTablePage={
                              batchTablePages[`${selectedTab}-${section}`] || 0
                            }
                            setBatchTablePage={(page) => {
                              setBatchTablePages((prev) => ({
                                ...prev,
                                [`${selectedTab}-${section}`]: page,
                              }));
                            }}
                            nimbleTablePage={
                              nimbleTablePages[`${selectedTab}-${section}`] || 0
                            }
                            setNimbleTablePage={(page) => {
                              setNimbleTablePages((prev) => ({
                                ...prev,
                                [`${selectedTab}-${section}`]: page,
                              }));
                            }}
                            matchedTablePage={
                              matchedTablePages[`${selectedTab}-${section}`] ||
                              0
                            }
                            setMatchedTablePage={(page) => {
                              setMatchedTablePages((prev) => ({
                                ...prev,
                                [`${selectedTab}-${section}`]: page,
                              }));
                            }}
                            chargebackTablePage={
                              chargebackTablePages[`${selectedTab}-${section}`] ||
                              0
                            }
                            setChargebackTablePage={(page) => {
                              setChargebackTablePages((prev) => ({
                                ...prev,
                                [`${selectedTab}-${section}`]: page,
                              }));
                            }}
                            saveScrollPosition={saveScrollPosition}
                            getScrollPosition={getScrollPosition}
                            batchCardCache={batchCardCache}
                            nimbleCardsCache={nimbleCardsCache}
                          />
                        )}

                        {index < 2 && (
                          <TableRow>
                            <TableCell
                              colSpan={100}
                              sx={{ p: 1, border: "none" }}
                            />
                          </TableRow>
                        )}
                      </>
                    );
                  },
                )}
              </TableBody>
            </Table>
          </Stack>
        </DialogContent>
      </Box>
      {loading && <Loader loading={loading} />}
    </Dialog>
  );
};

export default MerchantReconciliationDialog;
